import IsoToDateTime, { IsoToDateWithoutTime } from "./IsoDateTime";
import { convertToAge } from "./ProcessData";

export const ProcessDataForExpress = (data, config) => {
  if (!data || !config) return; // Early return if data or config is falsy
  const dates = config?.dateKeys || ["createdAt", "updatedAt"];
  const deleteKey = config?.deleteKeys || ["__typename"];
  const dateWithoutTime = config.dateKeysWithoutTime || [];
  const addcol = config?.AddCol;
  const Age = config?.calculateAge;
  const specialCases = config?.specialCases;
  const updatedData = data?.map((el) => {
    let obj = { ...el };
    Object.entries(el).forEach(([key, value]) => {
      if (typeof value === "object" && value !==null) {
        delete obj[key];
      }
    });
    if (Age) {
      if (obj[Age]) obj.Age = convertToAge(obj[Age]);
    }
    dates?.map((item) => {
      if (obj[item]) obj[item] = IsoToDateTime(obj[item]);
    });
    dateWithoutTime?.forEach((key) => {
      if (obj[key]) obj[key] = IsoToDateWithoutTime(obj[key]);
    });
    deleteKey?.forEach((key) => {
      if (obj[key]) delete obj[key];
    });
    specialCases?.forEach((caseRule) => {
      if (caseRule.condition && caseRule.action) {
        if (caseRule.condition(obj)) {
          caseRule.action(obj);
        }
      }
    });
    addcol?.map((el) => {
      obj[el?.colName] = el?.value(obj);
    });
    return obj;
  });
  return updatedData;
};
